import { render, staticRenderFns } from "./user-access.vue?vue&type=template&id=3cefaa21&"
import script from "./user-access.vue?vue&type=script&lang=js&"
export * from "./user-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports